import {component, EntityData, transientIdentifier} from "@fedeltapointofsale/data-client";
import {MixAndMatchInclusionSellableData} from "./mix-and-match.data";
import {TypedCustomObjectReferenceData} from "../../custom-objects/custom-object/custom-object.data";

export class MixAndMatchInclusionSearchData extends EntityData<MixAndMatchInclusionSearchData> {
    @component sellable: MixAndMatchInclusionSellableData;
    @component customObject: TypedCustomObjectReferenceData;

    @transientIdentifier get id(): string {
        return this.sellable && this.sellable.sellableId ? "sellable_" + this.sellable.sellableId : "customObject_" + this.customObject.customObjectId;
    }

    get name(): string {
        return this.sellable && this.sellable.sellableId ? this.sellable.name : this.customObject.name;
    }

    get descriptor(): string {
        return this.sellable && this.sellable.sellableId ? this.sellable.name : "[" + this.customObject.customObjectType.name + "] - " + this.customObject.name;
    }
}
